<template>
  <!--说明是否要popover-->
    <div class="cost background-supplement-no-title-layout">
        <div class="layout-content" v-loading="loading">
            <div class="cost-amount">
                学费余额：<span> ￥{{ fee.remainValue || 0 }}</span>
                <el-button type="primary" @click="goRecharge" class="cash" :disabled="btnDisabled">立即充值</el-button>
            </div>
            <ul class="cost-list">
                <li v-for="(list, index) in fee.records" :key="index" class="list-li">
                    <div class="list-left">
                        <!-- <i class="income" v-if="list.moneyAmount>0">收</i>
                        <i class="spending" v-else>支</i> -->
                        <div>
                            <el-popover
                                  placement="bottom-start"
                                  width="auto"
                                  trigger="hover"
                                  :content="list.remark">
                                  <span slot="reference" class="cost-space-text">
                                      <span v-if="list.moneyAmount < 0" class="pay">{{ list.remark }}</span>
                                      <span v-else class="in">{{ list.remark }}</span>
                                  </span>
                            </el-popover>
                            <p> {{ list.time }}</p>
                        </div>
                    </div>
                    <div class="list-right">
                       <el-button v-if="list.analysesBillId" @click="goRechargeSingle(list)" class="rechange-single-button">去充值</el-button>
                       <div v-else>
                            <p><b style="font-weight:normal;" v-if="list.moneyAmount>0">+</b>{{ list.moneyAmount }}</p>
                            <span v-if="list.isCancelled" style="margin-left: 10px;">已取消充值</span>
                       </div>
                    </div>
                </li>
            </ul>
            <div class="pagination">
                <el-pagination
                    style="text-align:center"
                    v-if="fee.total > limit"
                    @current-change="handleCurrentChange"
                    :current-page.sync="currentPage"
                    :page-size="20"
                    layout="prev, pager, next"
                    :total="fee.total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import Moment from 'moment';

export default {
    data() {
        return {
            flag: true, // 防重复点击
            loading: false,
            currentPage: 1, // 当前页
            limit: 20,
            fee: {
                remainValue: 0, // 学费余额
                records: [],
                total: 0
            },
            btnDisabled: false
        };
    },
    beforeMount() {
        this.currentPage = 1;
        this.fetchFeeRecords();
    },
    methods: {
        fetchFeeRecords() {
            if (this.flag) {
                this.flag = false;
                this.loading = true;
                let limit = this.limit;
                this.$http
                    .get('/v1/payments/transactions/records', {
                        params: {
                            start: (this.currentPage - 1) * limit,
                            limit
                        }
                    })
                    .then(resp => this.$checkResp(resp, {}))
                    .then(data => {
                        let remainValue = data.remainValue ? data.remainValue / 100 : 0;
                        let records = data.records
                            ? data.records.map(item => {
                                item.time = item.time ? Moment(item.time).format('YYYY-MM-DD HH:mm:ss') : '';
                                item.moneyAmount = item.amount ? item.amount / 100 : 0;
                                item.remark = item.remark ? this.ExpRemark(item.remark) : '';
                                return item;
                            })
                            : [];
                        this.fee = Object.assign(
                            {},
                            {
                                remainValue,
                                records,
                                total: data.total || 0
                            }
                        );
                    })
                    .catch(err => {
                        this.$handleError(err.msg);
                        this.btnDisabled = true;
                    })
                    .finally(() => {
                        this.flag = true;
                        this.loading = false;
                    });
            }
        },
        handleCurrentChange(page) {
            this.currentPage = page;
            this.fetchFeeRecords();
        },
        goRecharge() {
            this.$router.push({ name: 'charge@record' });
        },
        goRechargeSingle(val) {
            // 小程序的订单金额转化为16进制拼到billid里
            let amount = val.amount.toString(16);
            let billInfo = val.analysesBillId + '-' + amount;
            this.$router.push({ name: 'charge@record', query: { billInfo: billInfo } });
        },
        ExpRemark(str) {
            let regExp = /#Re(.*?),/gi;
            let regExp2 = /#Re(.*?)*/gi;
            let rs = str.replace(regExp, '');
            rs = rs.replace(regExp2, '');
            return rs;
        }
    }
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.cash {
    background-image: linear-gradient(-269deg, #f44b4b 0%, #ff943b 100%);
    box-shadow: 0 4px 10px 0 rgba(244, 76, 75, 0.43);
    border-radius: 15px;
    border: none;
    top: 32px;
}

.cost-amount {
    width: 100%;
    height: 99px;
    line-height: 99px;
    // border: 1px solid #eee;
    background: url('../../../assets/images/record/bean_img_bg.png') no-repeat;
    background-size: cover;
    padding-left: 30px;
    color: #fff;
    font-size: 14px;
    display: flex;
    position: relative;

    span {
        font-size: 26px;
        color: #fff;
        margin: 0 10px;
    }
}

.cost-list {
    padding: 0 12px;

    .list-li {
        height: 81px;
        padding: 20px 0;
        border-bottom: 1px solid #e6e6e6;
        display: flex;
        justify-content: space-between;

        .list-left {
            display: flex;

            i {
                display: inline-block;
                width: 40px;
                height: 40px;
                text-align: center;
                line-height: 40px;
                border-radius: 50%;
                color: #fff;
                font-size: 18px;
            }

            .income {
                background-image: linear-gradient(-180deg, #fdbf04 0%, #fd7 100%);
            }

            .spending {
                background-image: linear-gradient(-180deg, #f5694e 0%, #ff9f8d 100%);
            }

            div {
                width: 650px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;

                p:first-of-type {
                    color: #4e3f3c;
                    height: 20px;
                    line-height: 20px;
                    font-size: 14px;
                    width: 650px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                p:last-of-type {
                    font-family: PingFangSC-Regular;
                    font-size: 12px;
                    color: #bfb2b0;
                }
            }
        }

        .list-right {
            p:first-of-type {
                height: 20px;
                text-align: right;
                font-size: 14px;
                color: #4e3f3c;
            }

            span:last-of-type {
                font-family: PingFangSC-Regular;
                font-size: 12px;
                color: #f4664b;
                text-align: right;
            }

            .rechange-single-button {
                width: 70px;
                height: 26px;
                padding: 0;
                margin-top: 7px;
                line-height: 24px;
                font-size: 12px;
                border: 1px solid #1daef8;
                color: #1daef8;
                background-color: #fff;
                border-radius: 2px;
            }
        }
    }

    .cost-space-text {
        height: 20px;
        display: inline-block;
        color: #4e3f3c;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/index/components/RecordTuition.vue